<template>
  <div class="card">
    <div class="card-body p-0">
      <cardHead
        :title="'Users'"
        :buttons="[
          {
            title: 'Reflesh',
            icon: 'fas fa-redo-alt',
            emit: 'get',
          },
        ]"
        @get="get"
      ></cardHead>
      <load-area v-if="data == null"></load-area>
      <dataTable
        :name="'Countries'"
        ref="agGrid"
        :columnDefs="columnDefs"
        v-if="data != null"
        :data="data"
        @directLogin="directLogin($event)"
        @cellDoubleClicked="rowCustomerDetail"
        @customerDetail="
          customerDetailShow = {
            Id: $event.CustomerId,
            Name: $event.CustomerName,
          }
        "
      ></dataTable>
    </div>
    <customerDetail
      v-if="customerDetailShow != null"
      :setModel="customerDetailShow"
      @close="customerDetailShow = null"
    ></customerDetail>
  </div>
</template>

<script>
import moment from "moment";
import customerDetail from "./../customers/detail/detail.vue";
export default {
  name: "Users",
  components: { customerDetail },
  data() {
    return {
      data: null,
      columnDefs: [
        {
          headerName: "Id",
          field: "Id",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          cellClick: true,
          width: 80,
        },
        {
          headerName: "Name",
          field: "Name",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "Customer Name",
          field: "CustomerName",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140
        },
        {
          headerName: "Phone",
          field: "Phone",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          cellClick: true,
          width: 140,
          valueFormatter: (e) => {
            return (
              e.value.slice(0, 4) +
              " " +
              e.value.slice(4, 7) +
              " " +
              e.value.slice(7, 11)
            );
          },
        },
        {
          headerName: "Email",
          field: "Email",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "BirthDate",
          field: "BirthDate",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          cellClick: true,
          width: 120,
          valueFormatter: function(params) {
            if (params.value == null) return null;
            let diff = new Date().getTimezoneOffset();
            return moment(
              new Date(params.value).setMinutes(
                new Date(params.value).getMinutes() - diff
              )
            ).format("DD.MM.YYYY");
          },
        },
        {
          headerName: "Active",
          field: "Active",
          enableRowGroup: true,
          filter: "agTextColumnFilter",
          floatingFilter: true,
          cellClick: true,
          width: 120,
          // Text filter "Aktif"/"Pasif" uzerinde calissin diye valueGetter string dondurur.
          valueGetter: function(params) {
            if (!params.data) return null;
            return params.data.Active ? "Aktif" : "Pasif";
          },
          cellRenderer: function(params) {
            if (!params.data) return params.value;
            var on = params.data.Active;
            // CustomerDetail user tablosuyla ayni dil: badge-success / badge-secondary.
            return (
              '<span class="badge badge-' +
              (on ? "success" : "secondary") +
              '">' +
              (on ? "Aktif" : "Pasif") +
              "</span>"
            );
          },
        },
        {
          headerName: "",
          type: "action",
          width: 80,
          buttons: [
            {
              classes: "btn btn-xs usr-act-btn waves-effect waves-light btn-info",
              text: '<i class="far fa-building"></i>',
              emit: "customerDetail",
            },
            {
              classes: "btn btn-xs usr-act-btn waves-effect waves-light btn-success",
              text: '<i class="fas fa-sign-in-alt"></i>',
              emit: "directLogin",
            },
          ],
          filter: false,
          sortable: false,
          resizable: false,
          floatingFilter: false,
        },
      ],
      customerDetailShow: null,
    };
  },
  created() {
    this.get();
  },
  methods: {
    rowCustomerDetail(e) {
      // Row'a CIFT-tik (bu sayfada herkes icin cift-tik) -> customerDetail ac.
      // Sagdaki aksiyon kolonuna tikta acma (butonlar kendi emit'ini yapar).
      if (!e || !e.data) return;
      if (e.colDef && e.colDef.type === "action") return;
      this.customerDetailShow = {
        Id: e.data.CustomerId,
        Name: e.data.CustomerName,
      };
    },
    get() {
      this.data = null;
      this.$appAxiosAdmin
        .get(`users`)
        .then((response) => {
          this.data = response.data.map((x) => {
            return {
              ...x,
              Phone: "0" + x.Phone,
            };
          });
        })
        .catch((err) => {
          // Kullaniciya toast yok (bilincli); takip loglardan.
          console.error("users yuklenemedi:", err);
        });
    },
    directLogin(item) {
      console.log(item);
      window.open(
        "https://direct.kolayrez.com/#/direct-login/" + item.DirectLoginKey,
        "_blank"
      );
    },
  },
};
</script>

<!-- NON-SCOPED: ag-grid cellRenderer HTML'i scoped data-v almadigi icin global. -->
<style>
/* Aksiyon butonlari standart btn-xs; sadece ikisi arasina kucuk bosluk. */
.usr-act-btn + .usr-act-btn {
  margin-left: 4px;
}
</style>
